import { createElement, forwardRef } from 'react'

import { splitProps } from '../helpers.mjs';
import { getTilesStyle } from '../patterns/tiles.mjs';
import { styled } from './factory.mjs';

export const Tiles = /* @__PURE__ */ forwardRef(function Tiles(props, ref) {
  const [patternProps, restProps] = splitProps(props, ["columns","rows","gutter","direction"])

const styleProps = getTilesStyle(patternProps)
const mergedProps = { ref, ...styleProps, ...restProps }

return createElement(styled.div, mergedProps)
  })